import { ENUM__ml_asset_family } from '@shared/dto/+model/sd/_enums/ENUM__ml_asset_family';
import { INVOCATION__base } from '../../_base/INVOCATION__base';

export class INVOCATION_VISION__base_cv2 extends INVOCATION__base {
  /*
   * PROPERTIES
   */
  get family() {
    return ENUM__ml_asset_family.VISION_CV2;
  }
}
